﻿<script>
	import { Router, Route, navigate } from "svelte-navigator";

	import registrationPageList from "./Registration/routes";
	import documentUploadPageList from "./FileUpload/routes";
	import FormColumn from "../components/FormColumn.svelte";
	import NavigationTracker from "../components/NavigationTracker.svelte";

	export let url = "";
	export let basepath = "/";

	let trackerPageList = [];

	const checkLandingUrl = function () {
		if (window.location.pathname.indexOf("/Registration") >= 0) {
			trackerPageList = registrationPageList;

			if (window.location.pathname !== "/Registration") {
				navigate("/Registration");
			}
		} else if (window.location.pathname.indexOf("/Review") >= 0) {
			trackerPageList = registrationPageList;

			if (window.location.pathname !== "/Review") {
				navigate("/Review");
			}

			return false;
		} else if (window.location.pathname.indexOf("/FileUpload") >= 0) {
			trackerPageList = documentUploadPageList;

			if (window.location.pathname !== "/FileUpload") {
				navigate("/FileUpload");
			}

			return false;
		} else if (
			window.location.pathname.indexOf("/Registration") < 0 &&
			window.location.pathname.indexOf("/FileUpload") < 0 &&
			window.location.pathname.indexOf("/Review") < 0
		) {
			trackerPageList = registrationPageList;
			navigate("/Registration");
		}

		return true;
	};

	if (checkLandingUrl()) {
		window.onbeforeunload = (event) => {
			event.returnValue = `Are you sure you want to leave?`;
		};
	}
</script>

<Router {url} {basepath}>
	<div class="row">
		<FormColumn cols="2"></FormColumn>
		<FormColumn cols="8">
			<NavigationTracker pageList={trackerPageList} />

			{#each trackerPageList as page, i}
				<Route path={page.routeId}>
					<svelte:component this={page.component} {...page.properties} pageName={page.title} />
				</Route>
			{/each}
		</FormColumn>
		<FormColumn cols="2"></FormColumn>
	</div>
</Router>

<style>
	.row {
		min-height: calc(100vh - 505px);
	}
</style>
